import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "../../../../axios/index"
import { useDidUpdate } from '../../../../hooks/useUpdate';

import { UserContext } from "../../../Context/UserContextProvider";

import { Link, useLocation } from "react-router-dom";

import UserManagmentChatDetailBox from "./UserManagmentChatDetailBox";
import ShowProfileModal from "../../DashboardFileManagement/CardDetail/ShowProfileModal";
import DashboardHeader from "../../DashboardReuseAbleComponents/DashboardHeader";
import DashboardSideMenu from "../../DashboardReuseAbleComponents/DashboardSideMenu";

// Styles
import styles from "./../UserManagment.module.css";
import Dstyles from "./../../DashboardFileManagement/DashboardFileManagement.module.css";

// Images
import arrowIcon from "./../../../../assets/img/DashboardICons/ArrowRounded.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const UserManagmentChatDetail = () => {
    const { userToken, userData } = useContext(UserContext);
    const { state } = useLocation();
    const [isLoading, setIsLoading] = useState(true);
    const [modalShow, setModalShow] = useState(false);
    const [sendMessageData, setSendMessageData] = useState({
        text: "",
        isSent: false
    });
    const history = useHistory();

    const inputRef = useRef(null)

    const [chatData, setChatData] = useState()
    // console.log(state)
    // console.log(userData)

    useEffect(() => {
        if (state.recieverName) {
            const dataHandler = async () => {
                const getMessages = await axios.get(
                    `Messages/${state.id}`,
                    {
                        headers: { authorization: "Bearer " + userToken },
                    }
                );
                // console.log(getMessages)
                setChatData(getMessages.data.data)
                setIsLoading(false)
            }

            dataHandler()
        }

    }, [userToken, state.id, state.recieverName])

    useDidUpdate(() => {
        if (sendMessageData.isSent) {
            const dataHandler = async () => {
                const getMessages = await axios.get(
                    `Messages/${state.id}`,
                    {
                        headers: { authorization: "Bearer " + userToken },
                    }
                );

                setChatData(getMessages.data.data)
                // console.log(getMessages.data.data)
                setIsLoading(false)
            }
            dataHandler()
        }

    }, [sendMessageData.isSent])

    return (
        <>
            <ShowProfileModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />

            {isLoading ? (
                <div className={Dstyles.loader_container}>
                    <div className={Dstyles.spinner}></div>
                </div>
            )
                : (
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className="col-md-9" >
                                <div className={`mt-3 px-0 pb-4 ${styles.file_cards_container}`}>
                                    <DashboardHeader onClick={() => setModalShow(true)} class="px-0" />

                                    <div
                                        className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-4 mx-4 px-3"
                                        dir="rtl"
                                    >
                                        <div className='w-100 d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2'>
                                            <a href="#" onClick={history.goBack}><img className='ms-2' src={arrowIcon} alt="icon" /></a>
                                            <div className={styles.text1}>
                                                {/* {state.recieverName} و {state.senderName} */}
                                                {/* {state.senderName} */}
                                                {state.senderId === userData.id ?
                                                    state.recieverName : state.senderName
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <UserManagmentChatDetailBox chatData={chatData} changeHandler={changeHandler} sendMessage={sendMessage} inputRef={inputRef} sendMessageKeyboadrd={sendMessageKeyboadrd} />

                                </div>
                            </div>
                            <div className='col-md-3'>
                                {/* sideMenu starts */}
                                <DashboardSideMenu manageUsers manageUsersChat />
                                {/* sideMenu ends */}
                            </div>
                        </div>
                    </div>
                )}
        </>
    )

    function changeHandler(event) {
        setSendMessageData((prev) => {
            return { ...prev, text: event.target.value };
        });
    };

    async function sendMessage() {
        var data = new FormData();
        data.append('MessageId', chatData.id);
        data.append('Text', sendMessageData.text);
        data.append('IsSeen', false);
        const apiData = await axios.post(
            "Messages/CreateMessageContent",
            data,
            {
                headers: { authorization: "Bearer " + userToken },
            }
        );
        // console.log(apiData)
        if (apiData.data.isSuccess) {
            inputRef.current.value = "";
            setSendMessageData((prev) => {
                return { ...prev, isSent: true };
            });
        }
    }

    async function sendMessageKeyboadrd(event) {
        if (event.keyCode === 13) {
            if (sendMessageData.text !== "") {
                var data = new FormData();
                data.append('MessageId', chatData.id);
                data.append('Text', sendMessageData.text);
                data.append('IsSeen', false);
                const apiData = await axios.post(
                    "Messages/CreateMessageContent",
                    data,
                    {
                        headers: { authorization: "Bearer " + userToken },
                    }
                );
                // console.log(apiData)
                if (apiData.data.isSuccess) {
                    inputRef.current.value = "";
                    setSendMessageData((prev) => {
                        return { ...prev, isSent: true };
                    });
                }
            }
        }
    }
}

export default UserManagmentChatDetail;
